import { Action } from '@ngrx/store';

export const ORDER_EBU_REQUEST = 'ORDER_EBU_REQUEST';
export const ORDER_EBU_SUCCESS = 'ORDER_EBU_SUCCESS';
export const ORDER_EBU_CONFIRM_REQUEST = 'ORDER_EBU_CONFIRM_REQUEST';
export const ORDER_EBU_CONFIRM_SUCCESS = 'ORDER_EBU_CONFIRM_SUCCESS';
export const ORDER_EBU_CONFIRM_FAILURE = 'ORDER_EBU_CONFIRM_FAILURE';
export const ORDER_EBU_VALIDATION_REQUEST = 'ORDER_EBU_VALIDATION_REQUEST';
export const ORDER_EBU_VALIDATION_SUCCESS = 'ORDER_EBU_VALIDATION_SUCCESS';
export const ORDER_EBU_VALIDATION_FAILURE = 'ORDER_EBU_VALIDATION_FAILURE';
export const ORDER_EBU_VALIDATION_REQUIRED_REQUEST =
  'ORDER_EBU_VALIDATION_REQUIRED_REQUEST';
export const ORDER_EBU_LOG = 'ORDER_EBU_LOG';

export class OrderEBUOption implements Action {
  type = ORDER_EBU_REQUEST;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionSuccess implements Action {
  type = ORDER_EBU_SUCCESS;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionConfirm implements Action {
  type = ORDER_EBU_CONFIRM_REQUEST;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionConfirmSuccess implements Action {
  type = ORDER_EBU_CONFIRM_SUCCESS;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionConfirmFailure implements Action {
  type = ORDER_EBU_CONFIRM_FAILURE;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionValidation implements Action {
  type = ORDER_EBU_VALIDATION_REQUEST;

  constructor(public payload?: any) {}
}
export class OrderEBUValidateSuccess implements Action {
  type = ORDER_EBU_VALIDATION_SUCCESS;

  constructor(public payload?: any) {}
}

export class OrderEBUValidateFailure implements Action {
  type = ORDER_EBU_VALIDATION_FAILURE;

  constructor(public payload?: any) {}
}

export class OrderEBUOptionValidationRequired implements Action {
  type = ORDER_EBU_VALIDATION_REQUIRED_REQUEST;

  constructor(public payload?: any) {}
}
export class OrderEbuLog implements Action {
  type = ORDER_EBU_LOG;

  constructor(public payload?: any) {}
}

export type Actions =
  | OrderEBUOption
  | OrderEBUOptionSuccess
  | OrderEBUOptionConfirm
  | OrderEBUOptionConfirmSuccess
  | OrderEBUOptionConfirmFailure
  | OrderEBUOptionValidation
  | OrderEBUValidateSuccess
  | OrderEBUValidateFailure
  | OrderEBUOptionValidationRequired
  | OrderEbuLog;
